export default {
    "type": "array",
    "items": {
        "type": "reference",
        "referenceType": "ekultur"
    }
}